// src/services/pftSurveyPublicService.js
//
// The patient's side of the PFT health survey (/health-survey/:siteId/:token, flag
// PFT_SURVEY_TEXT_ENABLED). No login: the link's token is the key, and both calls go
// through functions, so nothing about the patient is readable from a browser by query
// (unlike the referral mass text's public recipients).

import { FUNCTIONS_BASE } from "../config/functionsBase";

const post = async (name, body) => {
  const res = await fetch(`${FUNCTIONS_BASE}/${name}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  return { ok: res.ok, status: res.status, data };
};

/**
 * Look the link up. Resolves to { found, submitted, phone, address } (phone and
 * address from the PFT, for pre-filling). Throws on a network or server error; the
 * page then shows the form anyway (fails open, like the referral form).
 */
export const lookupPftSurvey = async ({ siteId, token }) => {
  const r = await post("pftSurveyLookup", { siteId, token });
  if (!r.ok) throw new Error(r.data.error || "lookup failed");
  return r.data;
};

/**
 * Submit the answers and the signed consent PDF (base64). Resolves when saved; throws
 * with `alreadySubmitted: true` if this link was already used.
 */
export const submitPftSurvey = async ({ siteId, token, answers, pdfBase64 }) => {
  const r = await post("pftSurveySubmit", { siteId, token, answers, pdfBase64 });
  if (r.ok) return r.data;
  const err = new Error(r.data.error || "submit failed");
  if (r.status === 409) err.alreadySubmitted = true;
  throw err;
};
